import { estateResidents, estates } from './endpoints'
import { authCall } from '.'
import { CustomPaginationQuery, PaginatedResident } from '../interfaces/resident'
import { PropertyDTO } from '../interfaces/landlord'

const LandlordDataSerivce = {
  getLandlordDataList: async ({ page = 1, size = 15, all }: CustomPaginationQuery) => {
    const url = `${estateResidents}?type=landlord&page=${page}&size=${size}&all=${all}`
    return authCall<PaginatedResident>({
      url,
      method: 'get',
    })
  },

  getOwnedProperties: async (landlordId: string) => {
    const url = `${estates}/properties?communityMemberId=${landlordId}&all=true`;

    return authCall<{ results: PropertyDTO[] }>({
      url,
      method: 'get',
    })
  }
}

export default LandlordDataSerivce
